<div class="relative w-full">
  <button
    aria-haspopup="listbox"
    aria-controls="options"
    [attr.aria-expanded]="isOpen()"
    cdkOverlayOrigin
    #overlay
    #trigger="cdkOverlayOrigin"
    class="flex justify-between items-center rounded border-black border px-3 py-2 h-[42px] bg-white text-mobileMd tablet:text-mobileMd desktop:text-desktopMd cursor-pointer w-full disabled:opacity-60"
    (click)="toggleOpen()"
    #selectButtonRef
    tabindex="0"
  >
    <div>
      @if (selectedOption()) {
        <div class="font-semibold">
          {{ selectedOption().label | scTranslate | async }}
        </div>
      } @else if (placeholder()) {
        <div class="opacity-60 font-light">{{ placeholder() }}</div>
      }
    </div>
    <sc-svg
      name="arrow-down"
      size="w-5 h-5"
      class="transform"
      [class.rotate-180]="isOpen()"
    ></sc-svg>
  </button>
  @if (isOpen()) {
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen() && !isDisabled()"
      (overlayOutsideClick)="isOpen.set(false)"
      [cdkConnectedOverlayWidth]="overlay.offsetWidth"
      [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
      (detach)="isOpen.set(false)"
    >
      <div
        id="options"
        class="flex flex-col w-full bg-white divide-y divide-borderColor max-h-[300px] overflow-y-auto"
        style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)"
        role="listbox"
      >
        <ng-content></ng-content>
      </div>
    </ng-template>
  }
</div>
